import React, { Component } from 'react'
import PropTypes from  'prop-types';
import { inject, observer } from "mobx-react";
import  { withStyles } from  '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe } from 'react-stripe-elements'
import StripeElementWrapper from './StripeElementWrapper'
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  }
});

@inject("authStore")
@inject("commonStore")
@observer
class StripeCardsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  handleSubmit = ev => {
    console.log('handleSubmit')
    console.log(this.props)
    ev.preventDefault();
   // console.log(CardNumberElement)
  //  const wrappedElement = CardNumberElement.ref.getWrappedInstance()
   // console.log(wrappedElement)
    //wrappedElement.clear()
    //this.expField.handleClear()
   // this.csvField.handleClear()

    if (this.props.stripe) {
      this.props.stripe
        .createToken()
        .then(payment => {
          console.log(JSON.stringify(payment))
          this.props.authStore.addPaymentMethod(payment.token)
        })
    } else {
      console.log('Form submitted before Stripe.js loaded.');
    }
  };
  handleClearMessage = () => {
    console.log('handleClearMessage')
    const { setPaymentProgress } = this.props.commonStore
    setPaymentProgress({isProcessing: false})
    //this.props.handleClose()
  }
  makeActions = () => {
    const { paymentProgress } = this.props.commonStore
    const { isProcessing, result, message } = paymentProgress

    console.log(isProcessing)

    if (!isProcessing && result === 'success'){
     // return (<Typography variant="body1">{message}<Button onClick={this.handleClearMessage}> OK </Button> </Typography>)
    }else if (!isProcessing && result === 'error'){
     // return (<Typography variant="body1">{message} <Button onClick={this.handleClearMessage}> OK </Button> </Typography>)
    }else if(!isProcessing) {
      return <Button variant="contained" color="primary"  onClick={this.handleSubmit}> Add New </Button>
    }else{
      return <LinearProgress color="secondary" /> 
    }
  }

  render() {
    const { paymentProgress } = this.props.commonStore
    const { isProcessing } = paymentProgress

    return (
     
      <Grid container spacing={24}>
      {isProcessing ? <LinearProgress /> : null}
        <Grid item xs={12}>
          <StripeElementWrapper ref={(ref) => { (this.cardNumberField = ref); }} label="Card Number" component={CardNumberElement} />
        </Grid>
        <Grid item xs={7}>
          <StripeElementWrapper ref={(ref) => { (this.expField = ref); }} label="Expiry (MM / YY)" component={CardExpiryElement} />
        </Grid>
        <Grid item xs={5}>
          <StripeElementWrapper ref={(ref) => { (this.csvField = ref); }} label="CVC" component={CardCVCElement} />
        </Grid>
        <Grid item xs={5}>
          {this.makeActions()}
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(injectStripe(StripeCardsSection));



// WEBPACK FOOTER //
// ./src/components/Stripe/StripeCardsSection.js